/* src/app/shared/components/view-access-code/dialogs/mfa-input-dialog/mfa-input-dialog.component.scss */
.close-icon {
  top: 1rem !important;
  right: 1rem !important;
}
.title {
  padding: 1.44rem 1.38rem;
  background-color: #F2F1EF;
}
.content {
  padding: 1rem 1.38rem;
}
.content .email {
  color: #004791;
}
.content form {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  column-gap: 0.5rem;
  width: 20rem;
  margin-bottom: 2rem;
}
.content form .mdc-button {
  padding: 0 1.5rem;
}
.content a.mdc-button {
  color: #004791;
}
.content .resend-message {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
:host(.mfa-input-dialog) {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  height: auto;
}
/*# sourceMappingURL=mfa-input-dialog.component.css.map */
